import { Component } from '@angular/core';
import { HelpService } from '@app/services/help.service';
import { UserService } from '@app/services/user.service';
import { GenericFormCarouselComponent } from '@app/helpers/generic-form-carousel-component';

@Component({
  selector: 'app-job-application-verified-modal',
  templateUrl: './job-application-verified-modal.component.html',
  styleUrls: ['./job-application-verified-modal.component.css']
})
export class JobApplicationVerifiedModalComponent extends GenericFormCarouselComponent {

  public idJob: Number = 0;
  public jobPosition: string = "";
  public jobTitle: string = "";
  public jobGradeFrom: string = "";
  public jobGradeTo: string = "";
  private modalName = 'modal-email-non-verified';
  constructor(public helpService: HelpService, private userService: UserService) {
    super("form-carousel-search-email-link");
  }

  setValues(id: Number, position: string, jobTitle: string, gradeFrom: string, gradeTo: string) {
    this.idJob = id;
    this.jobPosition = position;
    this.jobTitle = jobTitle;
    this.jobGradeFrom = gradeFrom;
    this.jobGradeTo = gradeTo;
    this.helpService.modalShow(this.modalName);
  }


  sendEmailLink(event: any) {

    event.preventDefault();

    this.userService.sendVerifyMail(this.userService.getIdCurrentUser()).toPromise().then(
      res => {
        if (res.status_code === 0) {
          this.setDataResponse();
        }
        else {
          this.setDataError(res.statusMessage)
        }
      },
      err => {
        this.setDataError(err)
      }
    );
  }

}